import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css';
import { hasMenuAccess, hasQualityPermission } from '../utils/permissions';

function Navbar({ user, onLogout, isFullscreen = false }) {
  const [hrSubmenuOpen, setHrSubmenuOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const hrMenuRef = useRef(null);

  const handleHRClick = (e) => {
    e.preventDefault();
    setHrSubmenuOpen(!hrSubmenuOpen);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setHrSubmenuOpen(false);
  };

  const handleSubmenuClick = (view) => {
    return (e) => {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('navigate', { detail: view }));
      setHrSubmenuOpen(false);
      closeMobileMenu();
    };
  };

  const handleNavClick = (view) => {
    return (e) => {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('navigate', { detail: view }));
      closeMobileMenu();
    };
  };

  // Zamykanie menu HR po kliknięciu poza nim
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (hrSubmenuOpen && hrMenuRef.current && !hrMenuRef.current.contains(event.target)) {
        setHrSubmenuOpen(false);
      }
    };

    if (hrSubmenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [hrSubmenuOpen]);

  return (
    <>
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}
      <nav className="navbar" style={isFullscreen ? { display: 'none' } : {}}>
        <div className="navbar-container">
          <div className="navbar-brand">
            <h1>MCG WorkSpace</h1>
          </div>
          <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu">
            <span className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          <div className={`navbar-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <button className="mobile-menu-close" onClick={closeMobileMenu} aria-label="Close menu">
              ✕
            </button>
            <div className="mobile-menu-content">
              {hasMenuAccess(user, 'dashboard') && (
                <a href="#dashboard" className="nav-link" onClick={handleNavClick('dashboard')}>Dashboard</a>
              )}
              {(hasMenuAccess(user, 'quality') || hasQualityPermission(user, 'view')) && (
                <a href="#quality-tablica" className="nav-link" onClick={handleNavClick('quality-tablica')}>Quality</a>
              )}
              {hasMenuAccess(user, 'kpi') && (
                <a href="#kpi" className="nav-link" onClick={handleNavClick('kpi')}>KPI</a>
              )}
              {hasMenuAccess(user, 'hr') && (
                <div className="nav-item-with-submenu" ref={hrMenuRef}>
                  <a href="#hr" className="nav-link" onClick={handleHRClick}>
                    HR
                    <span className="submenu-arrow">{hrSubmenuOpen ? '▲' : '▼'}</span>
                  </a>
                  {hrSubmenuOpen && (
                    <div className="submenu">
                      <a href="#hr-dodaj" className="submenu-link" onClick={handleSubmenuClick('hr-dodaj')}>Dodaj pracownika</a>
                      <a href="#hr-lista" className="submenu-link" onClick={handleSubmenuClick('hr-lista')}>Lista pracowników</a>
                      <a href="#hr-grafik2" className="submenu-link" onClick={handleSubmenuClick('hr-grafik2')}>Grafik 2</a>
                      <a href="#hr-rotacja" className="submenu-link" onClick={handleSubmenuClick('hr-rotacja')}>Rotacja</a>
                      <a href="#hr-absencje" className="submenu-link" onClick={handleSubmenuClick('hr-absencje')}>Absencje</a>
                    </div>
                  )}
                </div>
              )}
              {hasMenuAccess(user, 'admin') && (
                <a href="#admin" className="nav-link" onClick={handleNavClick('admin')}>Admin</a>
              )}
              {hasMenuAccess(user, 'database') && (
                <a href="#database" className="nav-link" onClick={handleNavClick('database')}>📊 Baza Danych</a>
              )}
            </div>
          </div>
          <div className={`navbar-user ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <span className="user-name">{user?.name || user?.email}</span>
            <button onClick={onLogout} className="logout-button">Wyloguj</button>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;

